import React, { useState } from "react";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import {
  PasswordSection,
  SectionTitle,
  PasswordActionsGrid,
  ActionCard,
  ActionCardTitle,
  ActionCardDescription,
  PasswordInputWrapper,
  InputLabel,
  PasswordStrengthHint,
} from "styles/components/userDetails.styles";

interface Props {
  dealerEmail: string;
  isChangingPassword: boolean;
  isSendingReset: boolean;
  onChangePassword: (newPassword: string) => void;
  onSendReset: () => void;
}

const DealerPasswordTab: React.FC<Props> = ({
  dealerEmail,
  isChangingPassword,
  isSendingReset,
  onChangePassword,
  onSendReset,
}) => {
  const [newPassword, setNewPassword] = useState("");

  const handleChange = () => {
    onChangePassword(newPassword);
    setNewPassword("");
  };

  return (
    <PasswordSection style={{ marginTop: "1rem" }}>
      <SectionTitle>
        <i className="pi pi-lock" />
        Password Management
      </SectionTitle>

      <PasswordActionsGrid>
        <ActionCard>
          <ActionCardTitle>
            <i className="pi pi-key" style={{ marginRight: "0.5rem" }} />
            Set New Password
          </ActionCardTitle>
          <ActionCardDescription>
            Set a new password for this dealer directly. Make sure to share it
            securely with the dealer afterwards.
          </ActionCardDescription>

          <PasswordInputWrapper>
            <InputLabel htmlFor="dealer-new-password">New Password</InputLabel>
            <Password
              inputId="dealer-new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Min. 8 characters"
              toggleMask
              feedback
              style={{ width: "100%" }}
              inputStyle={{ width: "100%" }}
            />
            <PasswordStrengthHint>
              Minimum 8 characters required.
            </PasswordStrengthHint>
          </PasswordInputWrapper>

          <Button
            label="Change Password"
            icon="pi pi-check"
            onClick={handleChange}
            loading={isChangingPassword}
            disabled={!newPassword || newPassword.length < 8}
            style={{ alignSelf: "flex-start" }}
          />
        </ActionCard>

        {/* Card 2 – Send reset email */}
        <ActionCard>
          <ActionCardTitle>
            <i className="pi pi-envelope" style={{ marginRight: "0.5rem" }} />
            Send Password Reset Email
          </ActionCardTitle>
          <ActionCardDescription>
            Send a password reset email to <strong>{dealerEmail}</strong>. The
            dealer will receive a temporary PIN to reset their own password
            securely.
          </ActionCardDescription>

          <Button
            label="Send Reset Email"
            icon="pi pi-send"
            className="p-button-outlined"
            onClick={onSendReset}
            loading={isSendingReset}
            style={{ alignSelf: "flex-start" }}
          />
        </ActionCard>
      </PasswordActionsGrid>
    </PasswordSection>
  );
};

export default DealerPasswordTab;
